import { render } from "./GenomicsView.vue?vue&type=template&id=fc7f4b94&ts=true"
import script from "./GenomicsView.vue?vue&type=script&lang=ts"
export * from "./GenomicsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__